import { FC, useMemo } from "react";
import { ComboGroupedElement } from "shared/components/Combobox/type";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import ComboContent from "./components/ComboContent";
import ComboFooter from "./components/ComboFooter";
import ComboHeader from "./components/ComboHeader";
import { StyledDrawer } from "./styled";

type ComboDrawerProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  groupedElements: ComboGroupedElement[];
  onSelectGroupedOptions: (values: string[]) => void;
  onClearSelectedOptions: () => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedValues: string[];
};

const ComboDrawer: FC<ComboDrawerProps> = ({
  onSelectGroupedOptions,
  open,
  anchorEl,
  handleClose,
  groupedElements,
  onClearSelectedOptions,
  selectedValues,
  searchQuery,
  setSearchQuery,
}) => {
  const totalSelectedAmount = useMemo(() => {
    return groupedElements.reduce((acc, curr) => {
      return (
        acc +
        curr.options.filter((option) => selectedValues.includes(option.value))
          .length
      );
    }, 0);
  }, [groupedElements, selectedValues]);

  const totalAmount = useMemo(() => {
    return groupedElements.reduce((acc, curr) => {
      return acc + (curr.options.length || 0);
    }, 0);
  }, [groupedElements]);

  return (
    <StyledDrawer
      open={open}
      id="combo-trigger-menu"
      aria-labelledby="combo-trigger-button"
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <FlexColumn height={382}>
        <ComboHeader
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        <ComboContent
          groupedElements={groupedElements}
          onSelectGroupedOptions={onSelectGroupedOptions}
          selectedValues={selectedValues}
          isExpandedAll={!!searchQuery}
        />
        <ComboFooter
          onClearAll={onClearSelectedOptions}
          totalAmount={totalAmount}
          selectedCount={totalSelectedAmount}
        />
      </FlexColumn>
    </StyledDrawer>
  );
};

export default ComboDrawer;
